import {
  RoleGuardComponent,
  RoleGuardProps,
} from 'baseComponents/RoleGuardComponent';
import { Navigate } from 'react-router-dom';

export const RoleRouteWrapper = ({
  children,
  ...rest
}: Omit<RoleGuardProps, 'fallback'>) => (
  <RoleGuardComponent fallback={<Navigate to='/home' replace />} {...rest}>
    <>{children}</>
  </RoleGuardComponent>
);
